import { CheckCircleOutlined } from "@mui/icons-material";
import { Link, Stack, SxProps, Tooltip, Typography, useTheme } from "@mui/material";
import { TaskItemDrawerContent, useDrawer } from "src/components";
import { Links } from "src/constants";
import { TaskItemParentDto } from "src/http";

interface IProps {
  parentTaskItem: TaskItemParentDto;
  showIcon?: boolean;
  hideTeamName?: boolean;
  condensed?: boolean;
  openDrawerOnClick?: boolean;
  sx?: SxProps;
}

const ParentTaskItemLabel = (props: IProps) => {
  const { parentTaskItem } = props;
  const { showDrawer } = useDrawer();
  const theme = useTheme();

  function handleTaskItemClicked() {
    showDrawer({
      content: <TaskItemDrawerContent taskItemGuid={parentTaskItem.taskItemGuid} />,
    });
  }

  return (
    <Stack
      direction="row"
      spacing={0.25}
      sx={{
        alignItems: "center",
        flexGrow: 1,
        minWidth: "0px",
        width: "100%",
        ...props.sx
      }}>
      {props.showIcon && <CheckCircleOutlined fontSize={props.condensed ? "small" : "medium"} />}
      <Tooltip
        placement="top-start"
        enterDelay={1000}
        enterNextDelay={1000}
        leaveDelay={500}
        title={
          <Typography variant="body1">
            {parentTaskItem.team && (
              <>
                <Link
                  href={Links.TeamImplementation(parentTaskItem.team.slug)}
                  onClick={(e) => e.stopPropagation()}
                  sx={{ fontWeight: "bold", textTransform: "uppercase" }}
                >
                  {parentTaskItem.team.name}
                </Link>
                {" : "}
              </>
            )}

            <Link
              href={Links.TaskItemDetail(parentTaskItem.taskItemGuid)}
              onClick={(e) => {
                if (props.openDrawerOnClick) {
                  e.preventDefault();
                  handleTaskItemClicked();
                }
                e.stopPropagation();
              }}
            >
              {parentTaskItem.description}
            </Link>
          </Typography>
        }
      >
        <Stack
          direction="row"
          spacing={0.25}
          sx={{
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
          <>
            {parentTaskItem.team && !props.hideTeamName && (
              <>
                <Link noWrap href={Links.Team(parentTaskItem.team.slug)} onClick={(e) => e.stopPropagation()}>
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{ fontSize: props.condensed ? 12 : "unset", textTransform: "uppercase" }}
                  >
                    {parentTaskItem.team.name}
                  </Typography>
                </Link>

                <Typography
                  variant="body2"
                  sx={{ pb: 0.1, fontSize: props.condensed ? 12 : "unset", mx: 0.25 }}
                  color={theme.palette.grey[300]}
                >
                  :
                </Typography>
              </>
            )}

            <Link
              noWrap
              href={Links.TaskItemDetail(parentTaskItem.taskItemGuid)}
              onClick={(e) => {
                if (props.openDrawerOnClick) {
                  e.preventDefault();
                  handleTaskItemClicked();
                }
                e.stopPropagation();
              }}
            >
              <Typography variant="body1" noWrap sx={{ fontSize: props.condensed ? 12 : "unset" }}>
                {parentTaskItem.description}
              </Typography>
            </Link>
          </>
        </Stack>
      </Tooltip>
    </Stack>
  );
};

export { ParentTaskItemLabel };
